import React, { useCallback, useMemo } from 'react';
import { Box } from '@mui/material';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import { MaterialReactTable } from 'material-react-table';
import _cloneDeep from 'lodash/cloneDeep';
import { styled } from '@mui/material/styles';
//
import { REPORT_COLUMN_DEFS } from 'utils/tables/columns/reports/daily';

const StyledTableContainer = styled(Box)(() => ({
  width: '100%',
  ['& tbody .MuiTableCell-body']: {
    whiteSpace: 'nowrap',
  },
}));
const filterColumnByAccessorKey = (reportDefs, id, accessorKey) =>
  reportDefs.map((item) => {
    if (item.id === id) {
      return {
        ...item,
        columns: item.columns.filter((col) => col.id === accessorKey),
      };
    }
    return item;
  });

const ReportTable = ({
  paginationModel,
  onPaginationChange,
  groupBy,
  ...props
}) => {
  const [columns, columnOrder] = useMemo(() => {
    // initial data for this set of columns
    const baseActiveColumns = filterColumnByAccessorKey(
      REPORT_COLUMN_DEFS,
      'groupBy',
      groupBy,
    );
    // need to clone data, because MRT actually modifies column data object, populating it with some internal stuff;
    // we also add 'id' column on the fly, because MRT seems to respect it way more during ordering
    const activeColumns = _cloneDeep(baseActiveColumns).map(
      ({ columns, ...group }) => ({
        ...group,
        columns: columns.map((column) => ({
          ...column,
          id: column.id || column.accessorKey,
        })),
      }),
    );
    // doc states that 'accessorKey' should be used here, but if id present, it's respected way higher
    const columnOrder = activeColumns
      .map(({ columns }) => columns.map(({ id }) => id))
      .flat();
    return [activeColumns, columnOrder];
  }, [groupBy]);
  const renderCustomActions = useCallback(
    () => (
      <Box display='flex' gap='1rem' p='0.5rem' flexWrap='wrap'>
        <div className='actions_cover active' style={{ padding: 0 }}>
          <div className='actions_cover-item' onClick={props.onDownload}>
            <FileDownloadIcon style={{ marginBottom: '-7px' }} />
            <span>Export data</span>
          </div>
        </div>
      </Box>
    ),
    [props.onDownload],
  );

  return (
    <StyledTableContainer>
      <MaterialReactTable
        columns={columns}
        data={props.rowData}
        rowCount={props.count}
        enableColumnResizing
        enableStickyHeader
        enableStickyFooter
        enableColumnActions={false}
        manualPagination
        muiPaginationProps={{
          rowsPerPageOptions: [100, 500, 1000],
        }}
        state={{
          isLoading: props.isRequestPending,
          pagination: paginationModel,
          columnOrder,
        }}
        renderTopToolbarCustomActions={renderCustomActions}
        onPaginationChange={onPaginationChange}
      />
    </StyledTableContainer>
  );
};

export default ReportTable;
